import TreeItem from "@mui/lab/TreeItem";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { useNavigate } from "react-router-dom";

import { styled } from "@mui/material/styles";
import { useDispatch, useSelector } from "react-redux";
import { hasCommonValue } from "../utils/api_params";
import { useEffect } from "react";
const CustomListItem = styled(ListItem)(() => ({
  "&.MuiButtonBase-root": {
    padding: "7px",
  },
}));
const CustomListItemText = styled(ListItemText)(({ theme }) => ({
  whiteSpace: "normal",
  overflowWrap: "break-word",
}));
export const IwdTreeItem = ({
  uuid,
  icon,
  title,
  children,
  section,
  disabled,
  link = false,
  hrefLink = false,
}) => {
  const navigate = useNavigate();
  const permessions = window.MENU[section];

  const onNavigatwClick = () => {
    if (link) {
      navigate(link);
    }
    if (hrefLink) {
      window.location.href = "/metrics";
    }
  };
  useEffect(() => {
    console.log("piiisyaapopa", permessions);
  }, [permessions, section]);
  const roles = useSelector((state) => state?.userPreferenceSlice.roles);

  return (
    <>
      {permessions?.visibility && hasCommonValue(roles, permessions?.roles) && (
        <TreeItem
          nodeId={uuid}
          disabled={disabled}
          onClick={onNavigatwClick}
          label={
            <CustomListItem sx={{ paddingLeft: 0 }} button>
              <ListItemIcon sx={{ color: "white" }}>{icon}</ListItemIcon>
              <CustomListItemText primary={title} />
            </CustomListItem>
          }
        >
          {children}
        </TreeItem>
      )}
    </>
  );
};
